module.exports = __webpack_public_path__ + "static/Stats_laptop_b.d3c3d50e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Stats_laptop_b.png
// module id = 63
// module chunks = 35783957827783 40787343088564